import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model, OData, $data } from 'src/core/services/data/JayDataContext';
import { computed } from 'mobx';
import { FormatService } from 'src/core/services/format.service';

export class QuoteItineraryGroupListDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.QuoteItineraryGroupSummary, Model.Bookings.Logic.ViewModels.QuoteItineraryGroupSummary, QuoteItineraryGroupSummary> {
	constructor(contextService: any, entitySet: (context: OData.Container) => $data.EntitySet<typeof Model.Bookings.Logic.ViewModels.QuoteItineraryGroupSummary, Model.Bookings.Logic.ViewModels.QuoteItineraryGroupSummary>, private formatService: FormatService) {
		super(contextService, entitySet);
	}

	protected map(entity: Model.Bookings.Logic.ViewModels.QuoteItineraryGroupSummary): QuoteItineraryGroupSummary {
		return new QuoteItineraryGroupSummaryModel(entity, this.formatService);
	}

	public static make(ctx: any, formatService: FormatService): QuoteItineraryGroupListDataService {
		return new QuoteItineraryGroupListDataService(ctx, ctx => ctx.QuoteItineraryGroupSummaries, formatService);
	}
}

export class QuoteItineraryGroupSummaryModel extends EntityModel<Model.Bookings.Logic.ViewModels.QuoteItineraryGroupSummary, QuoteItineraryGroupSummary> implements QuoteItineraryGroupSummary {
	@property<QuoteItineraryGroupSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<QuoteItineraryGroupSummaryModel>(o => o.entity.quoteNumber, (o, value) => o.entity.quoteNumber = value)
	public quoteNumber: string;

	@property<QuoteItineraryGroupSummaryModel>(o => o.entity.managedById, (o, value) => o.entity.managedById = value)
	public managedById: number;
	@property<QuoteItineraryGroupSummaryModel>(o => o.entity.managedByUserName, (o, value) => o.entity.managedByUserName = value)
	public managedByUserName: string;

	@property<QuoteItineraryGroupSummaryModel>(o => o.entity.dateFrom, (o, value) => o.entity.dateFrom = value)
	public dateFrom: Date;
	@computed
	public get dateFromText(): string {
		return this.dateFrom == null ? null : this.formatService.toString('short-date', this.dateFrom, 'utc');
	}

	@property<QuoteItineraryGroupSummaryModel>(o => o.entity.dateTo, (o, value) => o.entity.dateTo = value)
	public dateTo: Date;
	@computed
	public get dateToText(): string {
		return this.dateTo == null ? null : this.formatService.toString('short-date', this.dateTo, 'utc');
	}

	@property<QuoteItineraryGroupSummaryModel>(o => o.entity.tourItineraryName, (o, value) => o.entity.tourItineraryName = value)
	public tourItineraryName: string;

	@property<QuoteItineraryGroupSummaryModel>(o => o.entity.tourItineraryService, (o, value) => o.entity.tourItineraryService = value)
	public tourItineraryService: string;

	@property<QuoteItineraryGroupSummaryModel>(o => o.entity.tourItineraryDateId, (o, value) => o.entity.tourItineraryDateId = value)
	public tourItineraryDateId: number;

	@property<QuoteItineraryGroupSummaryModel>(o => o.entity.reservationsCount, (o, value) => o.entity.reservationsCount = value)
	public reservationsCount: number;


	@property<QuoteItineraryGroupSummaryModel>(o => o.entity.documentsLibraryId, (o, value) => o.entity.documentsLibraryId = value)
	public documentsLibraryId: string;

	

	constructor(entity: Model.Bookings.Logic.ViewModels.QuoteItineraryGroupSummary, private formatService: FormatService) {
		super(entity);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-groups/list/quote-group-list.data.ts